import { Directive, ElementRef, HostListener, Input } from "@angular/core";

@Directive({
    selector: '[uppercaseInput]',
    standalone: true
})
export class UppercaseInputDirective {

    @Input() appUppercaseInput: boolean = true;

    constructor(private el: ElementRef) {}

    @HostListener('input', ['$event'])
    onInput(event: Event): void {
        const inputElement = this.el.nativeElement as HTMLInputElement;
        const originalValue = inputElement.value;
        const upperCaseValue = originalValue.toUpperCase();

        if (originalValue !== upperCaseValue) {
            inputElement.value = upperCaseValue;
        }
    }
}